import { BehaviorSubject } from 'rxjs/BehaviorSubject';

/**
* Interfaces for datatable
*/
// interface for datatable.config
export interface NmDatatableCommonSettings {
	ajaxBeforeSend?: (xhr:any, settings:any) => void,
	ajaxAfterSend?: (xhr:any, status:any) => void,
	ajaxDataMassage?: (data: any[]) => any[],
	ajaxUrlMassage?: (url: string) => string,
	actionButtonCallback?: { [name: string]: (id:string, data: any) => void },
};

// interface for @Input [settings]
export interface NmDatatableSettings {
	modelName: string, // model name for the datatable

	fields?: [{
		name: string, 			// field name of the data, hierarchy as foo.bar
		data?: string, 			// field name of the data, hierarchy as foo.bar
		label: string, 			// label to be shown in thead
		width?: string, 			// width for the field
		sortable?: boolean, 	// allow/disallow sort, default true
		searchable?: boolean, // allow/disallow search, default true
		valueGetter?: (data:any)=>any,	// optional, a lambda to extract/massage data for display in the datatable cell
		search?: string,
		regex?: boolean
	}],

	pluginOptions?: pluginOptions, // datatable settings, ref: https://datatables.net/reference/option/

	data?: BehaviorSubject<any>, // optional if ajax is set, expected array of object
	dataMassage?: (data: any[]) => any[], // data massage

	// optional if data is set, expected api endpoint
	ajax?: {
		url?: string,
		contentType?: boolean | string,
		data?: any,
		method?: string,
	}, 
	ajaxBeforeSend?: (xhr:any, settings:any) => void, // before ajax send (ajax.beforeSend)
	ajaxAfterSend?: (xhr:any, status:any) => void, // after ajax send (ajax.complete)
	ajaxDataMassage?: (data: any[]) => any[], // data massge for ajax

	providers?: any[], // service provider for datatable.config

	enableActions?: boolean, // enable/disable action, default true
	actions?: { 						// default view, edit, delete, override this for custom actions
		name: string, 				// action name
		icon: string, 				// action icon, using font-awesome
		label?: string,
		color?: string, 			// action color, using ace-template: dark, white, red, red2, light-red, blue, light-blue, green, light-green, orange, orange2, light-orange, purple, pink, pink2, brown, grey, light-grey
		href?: string, 				// action href
		callback?: (id:string, data:any) => void | Promise<any>, // action callback, not calling pageService
		show?: (id:string, data:any) => boolean, // show if true, hide if false
	}[],

	enableMassActions?: boolean, // enable/disable mass action, default false
	massAction?: { 					// default delelte all, override this for custom actions
		name: string, 				// mass action name
		icon: string, 				// mass action icon, using font-awesome
		color?: string,  			// mass action color, please refer to action color (above)
		onClick?: any 				// mass action onclick event handler
	}[],
};

interface pluginOptions {
	autoWidth?: any,
	deferRender?: any,
	info?: any,
	lengthChange?: any,
	ordering?: any,
	paging?: any,
	processing?: any,
	scrollX?: any,
	scrollY?: any,
	searching?: any,
	serverSide?: any,
	stateSave?: any,
	createdRow?: any,
	drawCallback?: any,
	footerCallback?: any,
	formatNumber?: any,
	headerCallback?: any,
	infoCallback?: any,
	initComplete?: any,
	preDrawCallback?: any,
	rowCallback?: any,
	stateLoadCallback?: any,
	stateLoaded?: any,
	stateLoadParams?: any,
	stateSaveCallback?: any,
	stateSaveParams?: any,
	deferLoading?: any,
	destroy?: any,
	displayStart?: any,
	dom?: any,
	lengthMenu?: any,
	order?: any,
	orderCellsTop?: any,
	orderClasses?: any,
	orderFixed?: any,
	orderMulti?: any,
	pageLength?: any,
	pagingType?: any,
	renderer?: any,
	retrieve?: any,
	rowId?: any,
	scrollCollapse?: any,
	search?: {
		caseInsensitive?: any,
		regex?: any,
		search?: any,
		smart?: any,
	}
	searchCols?: any,
	searchDelay?: any,
	stateDuration?: any,
	stripeClasses?: any,
	tabIndex?: any,
	columnDefs?: {
		targets?: any,
	},
	columns?: {
		cellType?: any,
		className?: any,
		contentPadding?: any,
		createdCell?: any,
		data?: any,
		defaultContent?: any,
		editField?: any,
		name?: any,
		orderable?: any,
		orderData?: any,
		orderDataType?: any,
		orderSequence?: any,
		render?: any,
		responsivePriority?: any,
		searchable?: any,
		title?: any,
		type?: any,
		visible?: any,
		width?: any,
	},
	language?: {
		aria?: {
			paginate?: {
				first?: any,
				last?: any,
				next?: any,
				previous?: any,
			},
			sortAscending?: any,
			sortDescending?: any,
		},
		autoFill?: {
			button?: any,
			cancel?: any,
			fill?: any,
			fillHorizontal?: any,
			fillVertical?: any,
			increment?: any,
			info?: any,
		},
		decimal?: any,
		emptyTable?: any,
		info?: any,
		infoEmpty?: any,
		infoFiltered?: any,
		infoPostFix?: any,
		lengthMenu?: any,
		loadingRecords?: any,
		paginate?: {
			first?: any,
			last?: any,
			next?: any,
			previous?: any,
		},
		processing?: any,
		search?: any,
		searchPlaceholder?: any,
		select?: {
			cells?: any,
			columns?: any,
			rows?: any,
		},
		thousands?: any,
		url?: any,
		zeroRecords?: any,
	},
	autoFill?: {
		alwaysAsk?: any,
		columns?: any,
		editor?: any,
		enable?: any,
		focus?: any,
		update?: any,
	},	
	buttons?: {
		buttons?: {
			action?: any,
			available?: any,
			className?: any,
			destroy?: any,
			enabled?: any,
			extend?: any,
			init?: any,
			key?: any,
			name?: any,
			namespace?: any,
			text?: any,
			titleAttr?: any,
		},
		dom?: {
			button?: any,
			buttonContainer?: any,
			buttonLiner?: any,
			collection?: any,
			container?: any,
		},
		name?: any,
	},
	colReorder?: {
		fixedColumnsLeft?: any,
		fixedColumnsRight?: any,
		order?: any,
		realtime?: any,
	},
	fixedColumns?: {
		heightMatch?: any,
		leftColumns?: any,
		rightColumns?: any,
	},
	fixedHeader?: {
		footer?: any,
		footerOffset?: any,
		header?: any,
		headerOffset?: any,
	},
	keys?: {
		blurable?: any,
		className?: any,
		columns?: any,
		editor?: any,
		editorKeys?: any,
		focus?: any,
		keys?: any,
		tabIndex?: any,
	},
	responsive?: {
		breakpoints?: any,
		details?: {
			display?: any,
			renderer?: any,
			target?: any,
			type?: any,
		},
		orthogonal?: any,
	},
	rowGroup?: {
		className?: any,
		dataSrc?: any,
		enable?: any,
		endClassName?: any,
		endRender?: any,
		startClassName?: any,
		startRender?: any,
	},
	rowReorder?: {
		dataSrc?: any,
		editor?: any,
		enable?: any,
		formOptions?: any,
		selector?: any,
		snapX?: any,
		update?: any,
	},
	scroller?: {
		boundaryScale?: any,
		displayBuffer?: any,
		loadingIndicator?: any,
		rowHeight?: any,
		serverWait?: any,
	},
	select?: {
		blurable?: any,
		className?: any,
		info?: any,
		items?: any,
		selector?: any,
		style?: any,
	},
};


// WEBPACK FOOTER //
// ./src/widgets/datatable/datatable.interface.ts